import React, { useCallback } from 'react'
import InputCustom from 'components/Inputs'
import CustomSelect from 'components/Select'
import { FiTrash2 } from 'react-icons/fi'
import { Col, Row } from 'reactstrap'
import { shallowEqual, useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import * as simulacaoActions from 'store/modules/simulacao/actions'
import useRedux from 'hooks/useRedux'
import { BtnRemoveReferencia } from './style'
import { maskNome, maskNumber } from 'util/masks'
import { SIMULACAO } from 'store/modules/simulacao/types'

interface Props {
  indexReferencia: number
}

const Referencia = ({ indexReferencia }: Props) => {
  const { referencias, invalidsReferencias, optionsSelect } = useSelector<
    ApplicationState,
    SIMULACAO
  >((state) => state.simulacao, shallowEqual)

  const { dispatch } = useRedux()

  type ReferenciasField = keyof SIMULACAO['referencias'][number]
  const onChange = <T extends ReferenciasField>(
    value: T extends ReferenciasField
      ? SIMULACAO['referencias'][number][T]
      : never,
    field: T
  ) => {
    dispatch(
      simulacaoActions.setReferenciasField(value, field, indexReferencia)
    )
  }

  const handleRemove = useCallback(() => {
    dispatch(simulacaoActions.removeReferencia(indexReferencia))
  }, [dispatch, indexReferencia])

  return (
    <div className="container-fluid mb-4">
      <Row>
        <Col md={4}>
          <label className="label-12">Nome*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              const value = maskNome(e.target.value)
              onChange(value, 'nome')
            }}
            value={referencias[indexReferencia].nome}
            invalid={invalidsReferencias[indexReferencia].nome.invalid}
            errorMessage={invalidsReferencias[indexReferencia].nome.message}
            maxLength={100}
          />
        </Col>
        <Col md={1}>
          <label className="label-12">DDD*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              onChange(maskNumber(e.target.value), 'ddd')
            }}
            value={maskNumber(referencias[indexReferencia].ddd)}
            invalid={invalidsReferencias[indexReferencia].ddd.invalid}
            errorMessage={invalidsReferencias[indexReferencia].ddd.message}
            maxLength={3}
          />
        </Col>
        <Col md={3}>
          <label className="label-12">Número*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              onChange(maskNumber(e.target.value), 'numero')
            }}
            value={maskNumber(referencias[indexReferencia].numero)}
            invalid={invalidsReferencias[indexReferencia].numero.invalid}
            errorMessage={invalidsReferencias[indexReferencia].numero.message}
            maxLength={9}
          />
        </Col>
        <Col md={4}>
          <label className="label-12">Tipo de Referência*</label>
          <CustomSelect
            options={optionsSelect.grausReferencia}
            placeholder="Selecione"
            onChange={(e) => {
              onChange(e, 'grauReferenciaCrefazId')
            }}
            value={referencias[indexReferencia].grauReferenciaCrefazId}
            accessorLabel="descricao"
            accessorValue="id"
            invalid={
              invalidsReferencias[indexReferencia].grauReferenciaCrefazId
                .invalid
            }
            errorMessage={
              invalidsReferencias[indexReferencia].grauReferenciaCrefazId
                .message
            }
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex my-2">
          <BtnRemoveReferencia
            onClick={() => {
              handleRemove()
            }}
            className="btn"
          >
            <FiTrash2 className="icon" />
            Remover referência
          </BtnRemoveReferencia>
        </Col>
      </Row>
    </div>
  )
}

export default React.memo(Referencia)
